import { render, staticRenderFns } from "./domainForm.vue?vue&type=template&id=551f9f51"
import script from "./domainForm.vue?vue&type=script&lang=js"
export * from "./domainForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports